module.exports = __webpack_public_path__ + "media/images/about-trainer_profile-ginji@2x-71e3e234d4a425fe098eab30cd14f808.jpg";